import { ScreenNames } from "./ScreenNames"

export enum ScreenPaths {
    //Authentication
    Login = `/${ScreenNames.Login}`,
    Register = `/${ScreenNames.Register}`,
    ForgotPassword = `/${ScreenNames.ForgotPassword}`,
    AccountSetUp = `/${ScreenNames.AccountSetUp}`,

    Dashboard = `/${ScreenNames.DashBoard}`,
    DashboardOnboarding = `/${ScreenNames.DashBoard}?newUserModalIndex=0`,
    //Account
    Account = `/${ScreenNames.Account}`,
    // Account = `/accountzzz`,
    Profile = `/${ScreenNames.Account}/${ScreenNames.Profile}`,
    Security = `/${ScreenNames.Account}/${ScreenNames.Security}`,
    Preferences = `/${ScreenNames.Account}/${ScreenNames.Preferences}`,

    // Root
    Messages = `/${ScreenNames.Messages}`,
    Alerts = `/${ScreenNames.Alerts}`,
    GettingStarted = `/${ScreenNames.GettingStarted}`,
    Success = `/${ScreenNames.Success}`,
    BrewMenuSuccess = `/${ScreenNames.Success}/${ScreenNames.BrewMenuSuccess}`,

    // Org
    TeamManagement = `/${ScreenNames.Organization}/${ScreenNames.TeamManagement}`,
    Billing = `/${ScreenNames.Organization}/${ScreenNames.Billing}`,
    OrgSettings = `/${ScreenNames.Organization}/${ScreenNames.OrgSettings}`,
    NewOrganization = `/${ScreenNames.Welcome}/${ScreenNames.NewOrganization}`,
    CustomizeOrganization = `/${ScreenNames.Welcome}/${ScreenNames.CustomizeOrganization}`,
    ChoosePlan = `/${ScreenNames.Welcome}/${ScreenNames.ChoosePlan}`,

    //Apps
    Apps = `/${ScreenNames.Apps}`,
    Operations = `/${ScreenNames.Apps}/${ScreenNames.App_Operations}`,
    Marketing = `/${ScreenNames.Apps}/${ScreenNames.App_Marketing}`,
    BrewMenu = `/${ScreenNames.Apps}/${ScreenNames.App_BrewMenu}`,
    BrewKnowledge = `/${ScreenNames.Apps}/${ScreenNames.App_BrewKnowledge}`,
    MediaLibrary = `/${ScreenNames.Apps}/${ScreenNames.App_MediaLibrary}`
}
